"use client"

import Logo from "@/../public/goodshift/logo.png"
import { Disclosure, DisclosureButton, DisclosurePanel } from "@headlessui/react"
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline"
import Image from "next/image"
import Link from "next/link"
import { usePathname } from "next/navigation"

export default function Navbar() {
  const router = usePathname()

  // Helper function to determine if a link is active
  const isActive = (path: string) => {
    if ((path == "/" && router == "/") || (path.length > 1 && router?.includes(path))) {
      return "border-red"
    }
    return "border-transparent"
  }

  const menuItems = [
    { name: "Home", href: "/" },
    { name: "Goede Doelen", href: "/charity" },
    { name: "Giftcard", href: "/giftcard" },
    { name: "Voor organisaties", href: "/voor-organisaties" },
    { name: "Over Ons", href: "/about" },
  ]

  return (
    <Disclosure as="nav" className="bg-white">
      <div className="px-4 lg:px-[1rem] mx-auto max-w-7xl">
        <div className="flex h-[72px] justify-between">
          <div className="flex">
            <div className="flex shrink-0 items-center max-w-3xs max-h-3xs">
              <Link href="/">
                <Image priority alt="Goodshift Logo" src={Logo.src} width={142} height={23} />
              </Link>
            </div>
            <span className="text-[8px] pt-[3px] mt-[16px] text-center font-bold text-white bg-red rounded-[11px] h-[18px] w-[63px] ml-[0.5rem]">
              Not for profit
            </span>
          </div>
          <div className="hidden md:ml-6 md:flex md:space-x-8 font-medium">
            {menuItems.map((item) => (
              <Link
                key={item.name}
                href={item.href}
                className={`inline-flex items-center border-b-2 px-1 pt-1 text-sm font-medium text-black hover:border-red ${isActive(item.href)}`}>
                {item.name}
              </Link>
            ))}
            {/* <Menu
              as="a"
              className="inline-flex items-center border-b-2 border-transparent px-1 pt-1 text-sm font-medium text-black hover:border-red">
              <div>
                <MenuButton>Over Ons</MenuButton>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="-10 0 30 30"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="inline float-right size-6">
                  <path strokeLinecap="round" strokeLinejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
                </svg>
              </div>
              <MenuItems
                transition
                className="absolute right-0 z-10 mt-[12rem] w-48 origin-top-right bg-white py-1 shadow-lgS transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in">
                {subMenuItems.map((subItem) => (
                  <MenuItem key={subItem.name}>
                    <Link
                      href={subItem.href}
                      className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:outline-none hover:border-red">
                      {subItem.name}
                    </Link>
                  </MenuItem>
                ))}
              </MenuItems>
            </Menu> */}
          </div>
          <div className="-mr-2 ml-2 flex items-center md:hidden">
            <DisclosureButton className="group relative inline-flex items-center justify-center rounded-md p-2 text-black-400 hover:bg-gray-100 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-purple-500">
              <span className="absolute -inset-0.5" />
              <span className="sr-only">Open main menu</span>
              <Bars3Icon aria-hidden="true" className="block size-6 group-data-[open]:hidden" />
              <XMarkIcon aria-hidden="true" className="hidden size-6 group-data-[open]:block" />
            </DisclosureButton>
          </div>
        </div>
      </div>

      <DisclosurePanel className="md:hidden">
        <div className="space-y-1 pb-0 pt-2">
          {menuItems.map((item) => (
            <DisclosureButton
              key={item.name}
              as="a"
              href={item.href}
              className={`block border-l-4 border-transparent py-2 pl-3 pr-4 text-base font-medium text-black hover:border-red sm:pl-5 sm:pr-6 ${isActive(item.href)}`}>
              {item.name}
            </DisclosureButton>
          ))}
          {/* <Menu
            as="a"
            className="block border-l-4 border-transparent py-2 pl-3 pr-4 text-base font-medium text-black hover:border-red hover:bg-gray-50 sm:pl-5 sm:pr-6 width-100">
            <div>
              <MenuButton className="width-[100%]">
                <span className="float-left">Over ons</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="inline float-right size-6">
                  <path strokeLinecap="round" strokeLinejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
                </svg>
              </MenuButton>
            </div>
            <MenuItems
              transition
              className="absolute left-0 mt-2 z-10 pl-4 w-full origin-top-right bg-white py-1 shadow-lgS transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in">
              {subMenuItems.map((subItem) => (
                <MenuItem key={subItem.name}>
                  <Link
                    href={subItem.href}
                    className={`block px-4 py-2 text-sm text-black hover:bg-gray-100 hover:text-black ${isActive(subItem.href)}`}>
                    {subItem.name}
                  </Link>
                </MenuItem>
              ))}
            </MenuItems>
          </Menu> */}
        </div>
      </DisclosurePanel>
    </Disclosure>
  )
}
